<template>
  <v-container>
    <component :is="getCellulariComponent" />
  </v-container>
</template>

<script>
  import { mapGetters, mapMutations } from 'vuex'

  import Index from './../components/magazzino/smartphones/Index'
  import Insert from './../components/magazzino/smartphones/Insert'

  export default {
    name: 'MagazzinoSmartphones',
    components: {
      Index,
      Insert
    },
    computed: {
      ...mapGetters([
        'getCellulariComponent'
      ])
    },
    methods: {
      ...mapMutations([
        'CHANGE_CELLULARI_COMPONENT'
      ])
    },
    destroyed() {
      this.CHANGE_CELLULARI_COMPONENT('Index')
    }
  }
</script>

<style>
</style>